import { useState, useEffect } from 'react'
import { getManagerDashboard } from './managerDashboardService'

export const useManagerDashboard = () => {
  const [overall, setOverall] = useState(null)
  const [teams, setTeams] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    getManagerDashboard()
      .then(data => {
        if (cancelled) return
        setOverall(data.overall ?? null)
        setTeams(data.teams ?? [])
        setLoading(false)
      })
      .catch(() => {
        if (cancelled) return
        setError('Failed to load dashboard')
        setLoading(false)
      })

    return () => { cancelled = true }
  }, [])

  return { overall, teams, loading, error }
}
